import { render, staticRenderFns } from "./noticeBar.vue?vue&type=template&id=5a0fc214"
import script from "./noticeBar.vue?vue&type=script&lang=js"
export * from "./noticeBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports